module.exports = __webpack_public_path__ + "img/1ca1154d-ca35-4903-aac0-8d09355f3a74.7b5b6375.webp";